import {useAuthStore} from '@frontend/stores'
import type {UserData} from '@frontend/types'

// Получить данные авторизованного пользователя.
export function useUserData(): UserData | null {
    return useAuthStore(state => state.user)
}
